import {NavLink, useHistory, useLocation} from "react-router-dom";
import {useState} from "react";
import $ from 'jquery';
import {toast} from "react-toastify";
import API_LINK from "../components/links/Link";

export default function ResetPassword() {
    const [isVisible, setIsVisible] = useState(false)
    const history = useHistory();
    const location = useLocation();

    async function submitHandle(event) {
        event.preventDefault();
        event.stopPropagation();
        let param = new URLSearchParams(location.search).get('email');
        var form = $('.RegisterForm');
        let formdata = new FormData(form[0]);
        let toaster;
        if (!form[0].checkValidity()) {
            toast.warn("Fill all the required(*) fields.")
        } else if (form.find('input[name="password"]').val().length <= 7) {
            toast.warn("Password must contains at least 8 digits");
        } else if (form.find('input[name="password"]').val() !== form.find('input[name="cpassword"]').val()) {
            toast.warn("Password does not match. Please check your password.");
        } else {

            form.find("button").attr("disabled", true);
            toaster = toast.loading("Processing...");
            try {
                formdata.append("page", "ResetPassword");
                formdata.append("email", param);

                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    redirect: 'follow'
                };

                await fetch(`${API_LINK}Authentication.php`, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        console.log(result);
                        if (result.status === 1) {

                            setTimeout(() => {
                                toast.update(toaster, {
                                    type: "success",
                                    render: "Password has been reset successfully.",
                                    isLoading: false,
                                    autoClose: toaster,
                                    closeButton: true,
                                    pauseOnHover: false,
                                    pauseOnFocusLoss: false,
                                })
                                // toast.info("We have shared a verification email.Please make sure to verify your account.");
                                form.find("button").attr("disabled", false);
                                form.trigger("reset");
                                history.push("/");
                            }, 1000)
                        } else {
                            toast.error("Server Error! Please try again later.")
                        }
                    })
                    .catch(error => console.log('error', error));
            } catch (e) {
                console.log(e);
            }

        }

    }

    return (
        <>
            <div className='auth-container' style={{justifyContent: "center"}}>
                {/*<div className="auth-image">*/}
                {/*    <img src={REGISTER} loading={"lazy"} alt="Login Image"/>*/}
                {/*</div>*/}
                <div className="auth-form register-form-container" data-aos='fade-left'>
                    <h4 className="title" style={{marginTop: 50, textAlign: "center"}}>Password Reset</h4>
                    <div className="header_text_center">
                        {/*<p style={{fontSize: 14, marginBottom: 30, textAlign: "center"}}>Please enter your email*/}
                        {/*    address.*/}
                        {/*    You will receive a link to create a new password via email.</p>*/}
                    </div>
                    <form noValidate className='RegisterForm' onSubmit={submitHandle}>
                        <div className="register-form">
                            <div className="form-group">
                                <input type="text" required placeholder={'Password*'} name={'password'}/>
                            </div>
                            <div className="form-group">
                                <input type="text" required placeholder={'Repeat Password*'} name={'cpassword'}/>
                            </div>
                        </div>
                        <div className="form-group">
                            <button type={"submit"} className='btn-login'>Reset Password</button>
                        </div>
                    </form>

                </div>
            </div>
        </>
    )
}
